import * as AppErrors from "./app.errors";
import { AppError } from "./AppError";
import * as HttpErrors from "./http.errors";
import * as KaspiErrors from "./kaspi.errors";
import * as MongooseErrors from "./mongoose.errors";
import * as PaymentCardErrors from "./payment-card.errors";
import * as PermissionErrors from "./permission.errors";
import * as TelegramErrors from "./telegram.errors";
import * as WhatsAppErrors from "./whatsapp.errors";

//

function getMessage(error: unknown) {
  if (error instanceof Error) return error.message;
  return JSON.stringify(error, null, 2);
}

//

export const appErrors = {
  getMessage,
  AppError,
  ...AppErrors,
  ...KaspiErrors,
  ...MongooseErrors,
  ...PaymentCardErrors,
  ...PermissionErrors,
  ...WhatsAppErrors,
  ...HttpErrors,
  ...TelegramErrors,
};
